/**
 * Users Actions - Redux Thunk Actions
 * Handles user-related API calls and state updates
 */

import UsersService from 'services/users.service';

// Action Types
export const USERS_ACTION_TYPES = {
  // Load Users List
  LOAD_USERS_REQUEST: 'LOAD_USERS_REQUEST',
  LOAD_USERS_SUCCESS: 'LOAD_USERS_SUCCESS', 
  LOAD_USERS_FAILURE: 'LOAD_USERS_FAILURE',

  // Delete User
  DELETE_USER_REQUEST: 'DELETE_USER_REQUEST',
  DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS',
  DELETE_USER_FAILURE: 'DELETE_USER_FAILURE',

  // UI Actions
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  CLEAR_CURRENT_USER: 'CLEAR_CURRENT_USER',
  SET_USERS_PAGE: 'SET_USERS_PAGE',
  SET_USERS_SEARCH: 'SET_USERS_SEARCH',
  SET_USERS_USER_TYPE: 'SET_USERS_USER_TYPE'
};

// Action Creators

/**
 * Load all users with pagination
 * @param {Object} params
 * @param {number} params.pageNumber - Page number
 * @param {number} params.pageSize - Items per page
 * @param {string} params.searchTerm - Search query
 * @returns {Function} Redux thunk function
 */
export const loadUsers = ({ pageNumber = 1, pageSize = 10, searchTerm = '', userType } = {}) => {
  return async (dispatch) => {
    dispatch({ type: USERS_ACTION_TYPES.LOAD_USERS_REQUEST });

    try {
      const response = await UsersService.getAllUsers({ pageNumber, pageSize, searchTerm, userType });
      dispatch({
        type: USERS_ACTION_TYPES.LOAD_USERS_SUCCESS,
        payload: {
          ...response,
          searchTerm,
          userType
        }
      });
    } catch (error) {
      dispatch({
        type: USERS_ACTION_TYPES.LOAD_USERS_FAILURE,
        payload: error.message || 'Failed to load users'
      });
    }
  };
};

/**
 * Load user by ID
 * @param {number} userId - User ID
 * @returns {Function} Redux thunk function
 */
/**
 * Delete user
 * @param {number} userId - User ID
 * @returns {Function} Redux thunk function
 */
export const deleteUser = (userId) => {
  return async (dispatch) => {
    dispatch({ type: USERS_ACTION_TYPES.DELETE_USER_REQUEST });

    try {
      const response = await UsersService.deleteUser(userId);
      dispatch({
        type: USERS_ACTION_TYPES.DELETE_USER_SUCCESS,
        payload: { userId, message: response.message }
      });
      
      // Reload users list after successful deletion
  dispatch(loadUsers());
      
      return response;
    } catch (error) {
      dispatch({
        type: USERS_ACTION_TYPES.DELETE_USER_FAILURE,
        payload: error.message || `Failed to delete user ${userId}`
      });
      throw error;
    }
  };
};

/**
 * Set current user for viewing/editing
 * @param {Object} user - User object
 * @returns {Object} Redux action
 */
export const setCurrentUser = (user) => ({
  type: USERS_ACTION_TYPES.SET_CURRENT_USER,
  payload: user
});

/**
 * Clear current user
 * @returns {Object} Redux action
 */
export const clearCurrentUser = () => ({
  type: USERS_ACTION_TYPES.CLEAR_CURRENT_USER
});

/**
 * Set current page for pagination
 * @param {number} page - Page number
 * @returns {Object} Redux action
 */
export const setUsersPage = (page) => ({
  type: USERS_ACTION_TYPES.SET_USERS_PAGE,
  payload: page
});

/**
 * Set search term for filtering
 * @param {string} searchTerm - Search term
 * @returns {Object} Redux action
 */
export const setUsersSearch = (searchTerm) => ({
  type: USERS_ACTION_TYPES.SET_USERS_SEARCH,
  payload: searchTerm
});

export const setUsersUserType = (userType) => ({
  type: USERS_ACTION_TYPES.SET_USERS_USER_TYPE,
  payload: userType
});